const $ = require('jquery');
const mustache = require('mustache');
const data = require('header.data');
const analytics = require('header.analytics');

class SimpleFlyout {
  constructor() {
    this.privateData = {};
    this.templates = {};
    this.templates.simpleList = `
      {{#allLink}} <a href="{{{allLink}}}"><span class="SimpleFlyout__header">{{name}}</span></a> {{/allLink}}
      {{^allLink}} <span class="SimpleFlyout__header">{{name}}</span> {{/allLink}}
      <div class="SimpleFlyout__divider"></div>
      <ul class="SimpleFlyout__list">
        {{#links}}
          <li class="SimpleFlyout__listItem">
            <a class="SimpleFlyout__link" href="{{{url}}}" title="{{name}}">{{name}}</a>
          </li>
        {{/links}}
        {{#allLink}}
          <li class="SimpleFlyout__listItem">
            <a data-type="direct" class="SimpleFlyout__link" href="{{{allLink}}}" title="View All">View All {{name}}</a>
          </li>
        {{/allLink}}
      </ul>
      `;

    this.templates.navLinks = `
    {{#navigationLinks}}
    {{#showOnMobile}}
    <li class="SimpleFlyout__listItem">
      <a{{#id}} data-id="{{id}}"{{/id}} class="SimpleFlyout__link SimpleFlyout__link--bold" href="{{link}}">
        {{#icon}}
          <div{{#id}} data-id="{{id}}"{{/id}} class="SimpleFlyout__link__icon">
          {{#shopalldepts}}
          <!-- All Dept -->
          <svg{{#id}} data-id="{{id}}"{{/id}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
            <g fill="none" fill-rule="evenodd" transform="translate(1 1)">
              <path stroke="#333" stroke-width="1.5" d="M.9217 0h17.6068s1.139.663 1.139 1.8588-1.4372 1.6942-1.4372 1.6942v1.6425s1.4975-.006 1.4975 1.6055c0 1.6116-1.3017 1.6323-1.3017 1.6323V20H1.1428V8.3977S.0827 8.243.0827 6.833c0-1.4102 1.459-1.5495 1.459-1.5495v-1.648S0 3.68 0 1.9705.9217 0 .9217 0z"/>
              <path stroke="#333" d="M10.019 4.4175L20 12.3925"/>
              <ellipse cx="9.9266" cy="4.4773" fill="#333" rx="1.1956" ry="1.1213"/>
            </g>
          </svg>
          {{/shopalldepts}}
          {{#savingscenter}}
          <!-- Saving Center -->
          <svg{{#id}} data-id="{{id}}"{{/id}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 20">
            <path fill="#333" fill-rule="evenodd" d="M26.5697 7.8744L19.1107.4332C18.8254.1452 18.3914 0 17.962 0c-.4272 0-.8605.1453-1.146.4332l-2.0107 2.0135L20.605 8.266c.5997.5947.819 1.3526.819 2.0738 0 .7278-.2193 1.4804-.819 2.0804l-6.329 6.349h2.54c1.146 0 1.721-.5745 2.2948-1.147l7.459-7.449c.5736-.5706.5736-1.7277 0-2.2988zM18.498 9.124l-7.503-7.4627c-.2857-.2853-.7228-.4305-1.1557-.4305-.4322 0-.8678.1452-1.1592.4305L1.158 9.124C.58 9.6973 0 10.261 0 11.4078v7.4642C0 19.445.58 20 1.158 20H8.68c1.1552 0 1.7365-.555 2.315-1.128l7.503-7.4643c.5773-.5757.5773-1.7105 0-2.2836zM4.8108 16.923c-.7688 0-1.397-.6294-1.397-1.3985 0-.764.6282-1.3707 1.397-1.3707.77 0 1.3962.6068 1.3962 1.3707 0 .769-.6262 1.3986-1.3963 1.3986z"/>
          </svg>
          {{/savingscenter}}
          </div>
        {{/icon}}
        {{title}}
      </a>
    </li>
    {{/showOnMobile}}
  {{/navigationLinks}}`;

    this.templates.level1Flyout = `
    {{#l1}}
      {{^hideL1}}
        <li class="SimpleFlyout__listItem">
          <a href="{{link}}" class="SimpleFlyout__link{{#activeHolidayClass}} SimpleFlyout__link--{{activeHolidayClass}}{{/activeHolidayClass}}" data-level="{{name}}" data-image="{{feature.image}}" data-title="{{feature.title}}" data-cta="{{feature.cta}}" data-link="{{feature.link}}" title="{{name}}">{{name}}</a>
        </li>
      {{/hideL1}}
    {{/l1}}
    `;
    this._logEventPath = this._logEventPath.bind(this);
    this._logEventPathTaskLink = this._logEventPathTaskLink.bind(this);
    this._clearUrl = this._clearUrl.bind(this);
    this._openSimpleMenuLevel2 = this._openSimpleMenuLevel2.bind(this);
    this._openSimpleMenuLevel3 = this._openSimpleMenuLevel3.bind(this);
    this._handleMenuLevel3 = this._handleMenuLevel3.bind(this);
    this._simpleMenuBack = this._simpleMenuBack.bind(this);
    this._showSimpleFlyout = this._showSimpleFlyout.bind(this);
    this._toggleSimpleFlyout = this._toggleSimpleFlyout.bind(this);
    this._showAllDepartmentsFlyout = this._showAllDepartmentsFlyout.bind(this);
    this._interactWithSimpleMenuLink =
      this._interactWithSimpleMenuLink.bind(this);
    this._capturePath = this._capturePath.bind(this);
    this._closeOnSearchOpen = this._closeOnSearchOpen.bind(this);
    this._closeSimpleFlyout = this._closeSimpleFlyout.bind(this);
    this.init = this.init.bind(this);
  }

  _logEventPath(type, pathArray) {
    // Get header at the beginning, then join them all
    return analytics.logEvent(type, ['header'].concat(pathArray).join('>'));
  }

  _logEventPathTaskLink(event) {
    let taskLinkText = $(event.target).text().trim();
    this._logEventPath('header click', [taskLinkText]);
  }

  _clearUrl(urlString) {
    return urlString === '#' ? '' : urlString;
  }

  _openSimpleMenuLevel2(event) {
    let $this = $(event.target);
    let level1Data = $this.data();
    let level1Url = $this.attr('href');
    let level1Name = $this.text();
    let requestLevel2Data;

    event.preventDefault();

    this.privateData.selectedLevel1 = level1Data.level;

    requestLevel2Data = data.getLevel2Data(level1Data.level);

    // If it worked
    requestLevel2Data.then((level2Data) => {
      let htmlContent = mustache.render(this.templates.simpleList, {
        links: level2Data,
        allLink: this._clearUrl(level1Url),
        name: level1Name,
      });

      $('#simplePanelLevel2 .SimpleFlyout__container').html(htmlContent);
      this._scrollToTop();
      this._showSimplePanel(2);
      this._logEventPath('header click', ['all departments', level1Name]);
    });

    // If it failed
    requestLevel2Data.catch(() => {
      this._logEventPath('header click', ['all departments', level1Name]).then(
        () => {
          // Go where we were going any way
          window.location.assign(level1Url);
        },
      );
    });
  }

  _openSimpleMenuLevel3(event) {
    let $this = $(event.target);
    let level1Name = this.privateData.selectedLevel1;
    let level2Name = $this.text();
    let level2Url = $this.attr('href');
    let requestLevel3Data;

    this.privateData.selectedLevel2 = level2Name;

    // if this isn't direction
    if ($this.data('type') !== 'direct') {
      event.preventDefault();

      // request the data
      requestLevel3Data = data.getLevel3Data(level1Name, level2Name);

      // If it worked
      requestLevel3Data.then((level3Data) => {
        // render this thing
        let htmlContent = mustache.render(this.templates.simpleList, {
          links: level3Data,
          allLink: this._clearUrl(level2Url),
          name: level2Name,
        });

        // put it in the DOM
        $('#simplePanelLevel3 .SimpleFlyout__container').html(htmlContent);
        this._scrollToTop();
        // Show the panel
        this._showSimplePanel(3);
        this._logEventPath('header click', [
          'all departments',
          level1Name,
          level2Name,
        ]);
      });

      // If it failed - could be that the index doesn't exist, or that its got no results
      requestLevel3Data.catch(() => {
        this._logEventPath('header click', [
          'all departments',
          level1Name,
          level2Name,
        ]).then(() => {
          // Go where we were going any way
          window.location.assign(level2Url);
        });
      });
    } else {
      // This is a direct link so log it now
      this._logEventPath('header click', [
        'all departments',
        level1Name,
        level2Name,
      ]);
    }
  }

  _handleMenuLevel3(event) {
    let $this = $(event.target);
    let level1Name = this.privateData.selectedLevel1;
    let level2Name = this.privateData.selectedLevel2;

    this._logEventPath('header click', [
      'all departments',
      level1Name,
      level2Name,
      $this.text().toLowerCase(),
    ]);
  }

  _simpleMenuBack(event) {
    if (event && event.type === 'touchend') {
      // prevent default to stop click firing for touch events
      event.preventDefault();
    }
    this._scrollToTop();
    // strangely, event is explicitly needed for FF but not for others...
    this._showSimplePanel($(event.target).data('level'));
  }

  _notifyMenuState(state) {
    // Use a namespaced event, pass along the state
    $(document).trigger('menuState', [
      {
        isOpen: state,
        menu: 'simple',
      },
    ]);
  }

  _showSimpleFlyout(event, open) {
    let menuShown = typeof open === 'undefined' ? true : open;
    let $button = $('#simpleMenuButton');

    this._notifyMenuState(menuShown);

    // toggle the menu state
    $('#simpleFlyout').toggleClass('SimpleFlyout--closed', !menuShown);

    // Togle the button state... its complicated
    $button
      .find('.SimpleMenu__close')
      .toggleClass('SimpleMenu__close--open', menuShown);
    $button
      .find('.SimpleMenu__menu')
      .toggleClass('SimpleMenu__menu--closed', menuShown);

    // reset the panel to the beginning
    this._showSimplePanel(0);

    if (menuShown) {
      // close the tooltips in case they are open
      $(document).trigger('closeHeaderTooltips');
      $(document).trigger('closeAllMenus');
      // show the masking layer if appropriate
      $(document).trigger('headerMask-show', menuShown);
    } else {
      $(document).trigger('headerMask-show', menuShown);
    }
  }

  _toggleSimpleFlyout(event) {
    let $simpleMenu = $('#simpleFlyout');
    let simpleMenuOpen = !!$simpleMenu.hasClass('SimpleFlyout--closed');

    event.preventDefault();
    event.stopPropagation();

    this._showSimpleFlyout(event, simpleMenuOpen);
  }

  _preventMaskClose(event) {
    event.stopPropagation();
  }

  _scrollToTop() {
    $(window).scrollTop(0);
  }

  _showAllDepartmentsFlyout() {
    $('#simplePanelLevel1 .SimpleFlyout__list').show();
    $(
      '#simplePanelLevel1 span, #simplePanelLevel1 div.SimpleFlyout__divider:eq(1)',
    ).show();
    this._scrollToTop();
    this._showSimplePanel(1);
    $(document).trigger('closeHeaderTooltips');
  }

  _interactWithSimpleMenuLink(event) {
    let flyoutID = $(event.target).attr('data-id');
    if (flyoutID) {
      event.preventDefault();
      if (flyoutID === 'departmentsFlyout') {
        this._showAllDepartmentsFlyout();
      }
    }
  }

  _showSimplePanel(level) {
    let thisLevel = parseInt(level, 10);

    $('#simpleFlyout')
      .find('.SimpleFlyout__wrapper')
      .toggleClass('SimpleFlyout__wrapper--level1', thisLevel === 1)
      .toggleClass('SimpleFlyout__wrapper--level2', thisLevel === 2)
      .toggleClass('SimpleFlyout__wrapper--level3', thisLevel === 3);
  }

  _closeOnSearchOpen(event, isOpen) {
    if (isOpen) {
      this._showSimpleFlyout(event, false);
    }
  }

  /**
   * Captures the path traversed by the user on click of the headers in L2 and L3.
   * This is used for analytics. And logs the path
   */

  _capturePath(event) {
    let $this = $(event.target);
    let path = ['all departments', this.privateData.selectedLevel1];
    this.privateData.selectedLevel2 !== undefined &&
      path.push(this.privateData.selectedLevel2);
    path.push($this.text());
    this._logEventPath('header click', path);
  }

  _closeSimpleFlyout(event) {
    this._showSimpleFlyout(event, false);
  }

  _renderLevel1Categories() {
    const modifiedTemplate = this.templates.level1Flyout;
    data
      .getLevel1Data()
      .then(function _renderLevel1Data(level1Data) {
        if (level1Data && !$.isEmptyObject(level1Data)) {
          const htmlContent = mustache.render(modifiedTemplate, {
            l1: level1Data,
          });
          $('#simplePanelLevel1 ul.SimpleFlyout__list')
            .empty()
            .html(htmlContent);
        }
      })
      .catch(() => {});
  }

  _renderConfiguredNavigation() {
    return new Promise((resolve, reject) => {
      const modifiedTemplate = this.templates.navLinks;
      data
        .getNavData()
        .then(function renderNavData(navData) {
          if (navData && !$.isEmptyObject(navData)) {
            const htmlContent = mustache.render(modifiedTemplate, {
              navigationLinks: navData,
            });
            $('#navigationLinksNonUtility').empty().html(htmlContent);
            resolve();
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  // bind to all the necessary elements
  init() {
    this._renderConfiguredNavigation()
      .then(() => {
        this._renderLevel1Categories();
      })
      .catch(() => {
        this._renderLevel1Categories();
      });

    // delegate to all the things
    $(document)
      .on('click touchend', '#simpleMenuButton', this._toggleSimpleFlyout)
      .on('click touchend', '#simpleFlyout', this._preventMaskClose)
      .on(
        'click touchend',
        '#simpleFlyout .SimpleFlyout__back',
        this._simpleMenuBack,
      )
      .on('click', '#simplePanelMain', this._interactWithSimpleMenuLink)
      .on(
        'click',
        '#simplePanelLevel1 .SimpleFlyout__link',
        this._openSimpleMenuLevel2,
      )
      .on(
        'click',
        '#simplePanelLevel2 .SimpleFlyout__link',
        this._openSimpleMenuLevel3,
      )
      .on(
        'click',
        '#simplePanelLevel3 .SimpleFlyout__link',
        this._handleMenuLevel3,
      )
      .on(
        'click',
        '#simplePanelMain .SimpleFlyout__list li.SimpleFlyout__listItem a.SimpleFlyout__link',
        this._logEventPathTaskLink,
      )
      .on('showSimpleFlyout', this._showSimpleFlyout)
      .on(
        'click touchend',
        '#simplePanelLevel2 .SimpleFlyout__header',
        this._capturePath,
      )
      .on(
        'click touchend',
        '#simplePanelLevel3 .SimpleFlyout__header',
        this._capturePath,
      )
      .on('searchState', this._closeOnSearchOpen)
      .on('click touchend', '#header-b2b', this._closeSimpleFlyout);
  }
}

module.exports = new SimpleFlyout();
